// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__1Mwez","inputWrap":"styles_inputWrap__1hOi2","input":"styles_input__2RPgw"};